import React, { Fragment, useCallback } from 'react';
import Home from 'pages/Home';

import { ForgotPasswordModal } from 'ui/ForgotPasswordModal';

export const PasswordReset = ({ history, ...props }) => {
  const onClose = useCallback(() => {
    history.push('/');
  }, [history]);

  return (
    <Fragment>
      <Home history={history} {...props} />
      <ForgotPasswordModal isOpen onClose={onClose} />
    </Fragment>
  );
};

export default PasswordReset;
